var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3327 14.6666H4.66602C4.39268 14.6666 4.16602 14.44 4.16602 14.1666C4.16602 13.8933 4.39268 13.6666 4.66602 13.6666H11.3327C11.606 13.6666 11.8327 13.8933 11.8327 14.1666C11.8327 14.44 11.606 14.6666 11.3327 14.6666Z",
    fill: "#D95353"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5668 3.67999L10.9001 5.58665C10.5468 5.83999 10.0401 5.68665 9.88681 5.27999L8.62681 1.91999C8.41348 1.33999 7.59348 1.33999 7.38015 1.91999L6.11348 5.27332C5.96015 5.68665 5.46015 5.83999 5.10681 5.57999L2.44015 3.67332C1.90681 3.29999 1.20015 3.82665 1.42015 4.44665L4.19348 12.2133C4.28681 12.48 4.54015 12.6533 4.82015 12.6533H11.1735C11.4535 12.6533 11.7068 12.4733 11.8001 12.2133L14.5735 4.44665C14.8001 3.82665 14.0935 3.29999 13.5668 3.67999ZM9.66681 9.83332H6.33348C6.06015 9.83332 5.83348 9.60665 5.83348 9.33332C5.83348 9.05999 6.06015 8.83332 6.33348 8.83332H9.66681C9.94015 8.83332 10.1668 9.05999 10.1668 9.33332C10.1668 9.60665 9.94015 9.83332 9.66681 9.83332Z",
    fill: "#D95353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCrown);
export default __webpack_public_path__ + "static/media/RedCrown.4ca66125d1df4843c57aeea51c0b421b.svg";
export { ForwardRef as ReactComponent };